module.exports = __webpack_public_path__ + "static/media/gameplay_bg_b_02.3ebb15e4.png";